

import React from 'react'

const HomeHeader = ({ pageDet }) => {

  const { title, subtitle1, subtitle2, cat1, cat1_desc, cat2, cat2_desc, cat3, cat3_desc, about_img_url, about_name, about_title, about_text, more_sandy, created_at, del } = pageDet
  
  return (
    <>
    <div className="relative isolate tops">
        {/* <div
          className="tops-shade absolute inset-x-0 -top-40 -z-10 transform-gpu overflow-hidden blur-3xl sm:-top-80"
          aria-hidden="true"
        >
          <div
            className="relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#ffe7aa] to-[#333552] opacity-30 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]"
            style={{
              clipPath:
                'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
            }}
          />
        </div> */}
        <div className="w-full cakes-cover">
          <div className="px-6 pt-40 pb-24 sm:px-40 sm:py-40 lg:px-16 bg-gray-900/70">
            <div className="hidden sm:mb-8 sm:flex sm:justify-center">
            </div>
            <div className="text-left m-auto max-w-7xl">
              <h1 className="text-4xl font-bold tracking-normal text-white sm:text-5xl">
                {title}
              </h1>
              <p className="mt-3 text-sm lg:text-lg leading-6.5 text-gray-300/90">
                {subtitle1}
              </p>
              <div className="mt-10 flex items-start justify-start gap-x-3">
                <a
                  href="/#contact"
                  className="rounded-md bg-violet-600/65 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-violet-600/50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange-500"
                >
                  Book Appointment
                </a>
                <a
                  href="/services/interpretation"
                  className="rounded-md bg-white px-3.5 py-2.5 text-sm font-semibold text-lightBlue-900 shadow-sm hover:bg-violet-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange-500"
                >
                  Request Interpreter <span aria-hidden="true">→</span>
                </a>
              </div>
            </div>
          </div>
        </div>
        {/* <div
          className="absolute inset-x-0 top-[calc(100%-13rem)] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[calc(100%-30rem)]"
          aria-hidden="true"
        >
          <div
            className="relative left-[calc(50%+3rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 bg-gradient-to-tr from-[#ffe7aa] to-[#ff8400] opacity-30 sm:left-[calc(50%+36rem)] sm:w-[72.1875rem]"
            style={{
              clipPath:
                'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
            }}
          />
        </div> */}
    </div>
    </>
  )
}

export default HomeHeader